// extracted by mini-css-extract-plugin
export default {"googleButton":"GoogleButton_googleButton__rpqHA"};